<template>
    <div id="home">
        <div class="section d-lg-flex" v-if="0">
            <div class="w-50"></div>
            <div class="w-50 d-flex justify-content-center">
                <div class="col-6">
                    <img src="static/transparent_logo.png"
                         alt=""
                         class="logo">
                </div>
            </div>
        </div>

        <div class="section d-lg-flex mt-5 pt-5">
            <div class="square order-2 col-lg-6 align-content-stretch" id="tower2"></div>

            <div class="square order-1 col-lg-6 bg-white d-flex justify-content-center align-items-center">
                <div class="text" v-if="eng">
                    <h1>About ACTtelecom</h1>
                    <h5 class="main-blue mb-4">With Us the Grass is Greener</h5>

                    <p class="mb-4">ACTtelecom is a provider of telecommunications in central Georgia area. Founded in Alpharetta, Georgia, ACTtelecom has diligently worked to provide greater Atlanta area with the highest quality construction delivered in a professional manner.</p>

                    <p>Our philosophy is simple. The key to success in any business is customer satisfaction. Our diverse experience, professional project delivery, and commitment to customer service have solidified our reputation and allow us to remain the first choice for utility construction. We strive to make working for, and with, ACTtelecom an exceptional experience.</p>
                </div>

                <div class="text" v-else>
                    <h1>Acerca de ACTtelecom</h1>
                    <h5 class="main-blue mb-4">Con nosotros, el futuro es más eficiente</h5>

                    <p class="mb-4">ACTtelecom es un proveedor de telecomunicaciones en el área de Georgia central. Fundada en Alpharetta, Georgia, ACTtelecom ha trabajado incansablemente por ofrecer la calidad más alta de servicios de contrucción en el sector de las telecomunicaciones en el área de Atlanta y sus alrededores.</p>

                    <p>Nuestra filosofía es simple: la satisfacción del cliente es la clave para el éxito. Con nuestra experiencia, desarrollo y entrega de proyectos, y compromiso con el cliente, nos hemos establecido como uno de los líderes en el sector. Tenemos como prioridad que la experiencia de trabajar con nosotros sea excepcional y sin ningún tipo de inconvenientes.</p>
                </div>
            </div>
        </div>

        <div class="mb-80 section d-lg-flex">
            <div class="square col-lg-6 align-content-stretch" id="towers"></div>

            <div class="square col-lg-6 bg-white d-flex text-center justify-content-center align-items-center">
                <div class="text main-blue" v-if="eng">
                    <h1 class="mb-4">From tower maintenance to decommission, we do it all!</h1>

                    <div class="text-center">
                        <button class="btn bg-dark-blue text-white">Contact Us</button>
                    </div>

                    <p class="mt-4"><strong>Or Call Us: 770-402-1653</strong></p>
                </div>

                <div class="text main-blue" v-else>
                    <h1 class="mb-4">Desde mantenimiento hasta desmontaje, nosotros podemos encargarnos!</h1>

                    <div class="text-center">
                        <button class="btn bg-dark-blue text-white">Contáctanos</button>
                    </div>

                    <p class="mt-4"><strong>O Llámanos: 770-402-1653</strong></p>
                </div>
            </div>
        </div>

        <div class="d-lg-flex text-center text-white mb-80 blue-banner">
            <div class="col-lg-4 bg-dark-blue justify-content-center d-lg-flex">
                <div class="col-xl-6">
                    <h1 class="icon mb-4"><i class="fas fa-shield-alt"></i></h1>
                    <h3 v-if="eng">Fully Bonded</h3>
                    <h3 v-else>Bonos de Respaldo</h3>
                </div>
            </div>

            <div class="col-lg-4 bg-main-blue justify-content-center d-lg-flex">
                <div class="col-xl-6">
                    <h1 class="icon mb-4"><i class="fas fa-award"></i></h1>
                    <h3 v-if="eng">Reliable & Trustworthy</h3>
                    <h3 v-else>Confiable y Responsable</h3>
                </div>
            </div>

            <div class="col-lg-4 bg-dark-blue justify-content-center d-lg-flex">
                <div class="col-xl-6">
                    <h1 class="icon mb-4"><i class="fas fa-clipboard-list"></i></h1>
                    <h3 v-if="eng">Professional & Experienced</h3>
                    <h3 v-else>Profesional y Experimentado</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'Home',

    props: ['eng']
  }
</script>

<style lang="sass" scoped>
#home
    padding-bottom: 80px

    .blue-banner
        h1.icon
            font-size: 80px
        > div
            padding: 100px 0

    .logo
        margin: 15vh 0
        /*background-color: rgba(255, 255, 255, 0.7)*/
        padding: 0 20px

    .section
        width: 1400px
        margin: auto

    .square
        height: 600px

    .text
        width: 500px

    #tower2
        background-image: url("/static/tower2.jpg")
        background-position: top center
        background-size: cover

    #towers
        background-image: url("/static/towers.jpg")
        background-position: top center
        background-size: cover

@media (max-width: 1420px)
    #home
        .blue-banner
            > div
                padding: 100px 0
        .section
            width: 1024px

        .square
            padding: 0 50px
            position: relative
        .text
            width: 100%

@media (max-width: 991px)
    #home
        .blue-banner
            /*height: calc(100vw - 200px)*/
        .section
            width: 100%

        .square
            height: calc(100vw - 200px)

@media (max-width: 414px)
    #home
        .square
            width: 100%
            height: auto
            min-height: 50vh
            padding: 20px
</style>



// WEBPACK FOOTER //
// src/components/Home.vue